import type {ActionDefinitionObject} from '../types/ActionDefinition';
import type {RowActions} from '../types/RowData';
import {filterCommonBulkActions} from '../utils/filterCommonBulkActions';

/**
 * Returns the subset of action definitions that are marked as bulk actions AND are common
 * to every selected row. Delegates to the unit-tested `filterCommonBulkActions` util; this
 * wrapper keeps the existing call-site name/signature stable.
 */
export const useBulkActions = (
  actionDefinitions: ActionDefinitionObject,
  selectedRowsActions: Array<RowActions>
): ActionDefinitionObject => filterCommonBulkActions(actionDefinitions, selectedRowsActions);
